export const KILOBYTE = 1000;
export const MEGABYTE = 1000 * 1000;
export const TEN_MEGABYTES = 10 * MEGABYTE;
export const TWENTY_FIVE_MEGABYTES = 25 * MEGABYTE;
export const GIGABYTE = MEGABYTE * 1000;

export function toReadableSize(size) {
  if (!size) {
    // if size is 0 also return empty string
    return "";
  }

  if (size > GIGABYTE) {
    return (size / GIGABYTE).toFixed(2) + " GB";
  }
  if (size > MEGABYTE) {
    return (size / MEGABYTE).toFixed(1) + " MB";
  }
  if (size > KILOBYTE) {
    return (size / KILOBYTE).toFixed(0) + " KB";
  }
  return size + " B";
}